/* tslint:disable */

declare var Object: any;
export interface ClassroomTranslationInterface {
  "classroomId": number;
  "languageCode": string;
  "name"?: string;
  "displayName"?: string;
  "description"?: string;
  "data"?: string;
  "createdAt"?: Date;
  "createdBy"?: number;
  "updatedAt"?: Date;
  "updatedBy"?: number;
  "id"?: number;
}

export class ClassroomTranslation implements ClassroomTranslationInterface {
  "classroomId": number;
  "languageCode": string;
  "name": string;
  "displayName": string;
  "description": string;
  "data": string;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "id": number;
  constructor(data?: ClassroomTranslationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ClassroomTranslation`.
   */
  public static getModelName() {
    return "ClassroomTranslation";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ClassroomTranslation for dynamic purposes.
  **/
  public static factory(data: ClassroomTranslationInterface): ClassroomTranslation{
    return new ClassroomTranslation(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ClassroomTranslation',
      plural: 'ClassroomTranslations',
      path: 'ClassroomTranslations',
      idName: 'id',
      properties: {
        "classroomId": {
          name: 'classroomId',
          type: 'number'
        },
        "languageCode": {
          name: 'languageCode',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "displayName": {
          name: 'displayName',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "data": {
          name: 'data',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
